"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSliderTabs = void 0;
const react_1 = require("react");
const utils_1 = require("./utils");
const useSliderTabs = (deps = []) => {
    const containerList = (0, react_1.useRef)(null);
    const scrollToElement = (fn) => (e) => {
        e.target.scrollIntoView({ inline: 'center', behavior: 'smooth', block: 'nearest' });
        fn === null || fn === void 0 ? void 0 : fn(e);
    };
    (0, react_1.useLayoutEffect)(() => {
        const observer = new MutationObserver((event) => {
            var _a, _b;
            const target = (_a = event === null || event === void 0 ? void 0 : event[0]) === null || _a === void 0 ? void 0 : _a.target;
            (_b = target === null || target === void 0 ? void 0 : target.querySelector('div[data-active="true"]')) === null || _b === void 0 ? void 0 : _b.scrollIntoView({
                inline: 'center',
                block: 'nearest',
            });
        });
        const resizeObserver = new ResizeObserver((event) => {
            var _a, _b;
            const target = (_a = event === null || event === void 0 ? void 0 : event[0]) === null || _a === void 0 ? void 0 : _a.target;
            (_b = target === null || target === void 0 ? void 0 : target.querySelector('div[data-active="true"]')) === null || _b === void 0 ? void 0 : _b.scrollIntoView({
                inline: 'center',
                block: 'nearest',
            });
        });
        if (containerList === null || containerList === void 0 ? void 0 : containerList.current) {
            (0, utils_1.makeHorizontalScrollable)(containerList === null || containerList === void 0 ? void 0 : containerList.current);
            observer.observe(containerList === null || containerList === void 0 ? void 0 : containerList.current, { subtree: false, childList: true });
            resizeObserver.observe(containerList === null || containerList === void 0 ? void 0 : containerList.current);
        }
        return () => {
            observer.disconnect();
            resizeObserver.disconnect();
        };
    }, [...deps]);
    return {
        containerList,
        scrollToElement,
    };
};
exports.useSliderTabs = useSliderTabs;
//# sourceMappingURL=useSliderTabs.js.map